import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { autobind } from 'core-decorators'
import { Link } from 'react-router'
import { ensureData } from '../../shared/utils/ensureData'

import { pickFromList, getConfig, formatMonth } from '../../shared/utils'
import FileList from '../../shared/components/FileList'

class PriceAccessorClass {
  constructor(prices) {
    this.prices = prices
  }

    priceKeys = [
      'generalPrice',
      'materialCosts',
      'minPrice',
      'costsByPerson',
    ]

    hasPrice(key) {
      const price = this.prices[key]
      return typeof price !== 'undefined' && parseFloat(price)
    }

    getPrice(key) {
      return this.hasPrice(key) ? this.prices[key] : ''
    }
}
const PriceAccessor = (props) => new Proxy(
  new PriceAccessorClass(props),
  {
    get(obj, key) {
      if (obj.priceKeys.indexOf(key) === -1) {
        throw new Error(`Key "${key}" is not a price key!`)
      }
      return obj.getPrice(key)
    }
  }
)

@inject('auth')
@observer
export default class Details extends Component {
  static propTypes = {
    auth: PropTypes.object,
    current: PropTypes.object.isRequired,
    messageError: PropTypes.object,
    onSendMessage: PropTypes.func
  };

  constructor(props) {
    super(props)
    this.state = {
      question: ''
    }
  }

  @autobind
  handleChange({ target: { name, value } }) {
    this.setState({ [name]: value })
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault()
    const {
      current: {
        program: { id },
        title
      }
    } = this.props

    if (this.props.onSendMessage) {
      this.props.onSendMessage({
        target: {
          value: {
            recipientUserId: id,
            recipientType: 'museum',
            subject: title,
            message: this.state.question,
            type: 'question'
          }
        }
      })
    }
  }

  renderList(name) {
    const listName = `list_${name}`

    const { current } = this.props
    const entries = current[`${name}s`.replace(/ss$/, 's')]

    if (!entries.length) {
      return <span>{ensureData('')}</span>
    }

    return (
      <ul className="info-list">
        {entries.map(({ value, attr }) => {
          const item = pickFromList(getConfig(listName), {
            key: 'id',
            value: value * 1
          })

          return (
            <li key={value}>
              <span className="info-list-label">{item.title}</span>
              {attr !== undefined ? `: ${attr}` : null}
            </li>
          )
        })}
      </ul>
    )
  }

  render() {
    const {
      current: {
        id,
        title,
        museum,
        description,
        duration,
        maxParticipants,
        meetingPoint,
        curriculums,
        bookingStart,
        bookingEnd,
        // bookableOutOfSeason,
        // generalPrice,
        // materialCosts,
        // minPrice,
        // costsByPerson,
        bookableOutOfOpeningTimes,
        specialConditionsForRemedialClasses,
        freeEntryForTeachersAtPrevisit,
        images,
        links
      },
      // may be defined for listening purposes only
      // eslint-disable-next-line no-unused-vars
      messageError
    } = this.props

    const prices = PriceAccessor(this.props.current)

    return (
      <div className="vertical program-layout">
        <div id="program-container">
          <div>
            <h2>
              {title}
              {this.props.auth.acs.isAuthorized('SUPERADMIN') ? (
                <Link
                  to={`/program/${id}/admin`}
                  className="btn btn-sm btn-link pull-right"
                >
                  Admin Einstellungen
                </Link>
              ) : null}
            </h2>
            von
            {' '}
            {museum.name}
            <div className="row">
              <div className="col-xs-6">
                <div className="data-group">
                  <h3>1. Allgemeine Informationen</h3>
                  <dl>
                    <dt>Dauer:</dt>
                    <dd>
                      {duration}
                      {' '}
                      (Minuten)
                    </dd>

                    <dt>Teilnehmer:</dt>
                    <dd>
                      {maxParticipants}
                      {' '}
                      (maximal)
                    </dd>

                    <dt>Treffpunkt:</dt>
                    <dd>{meetingPoint}</dd>

                    <dt>Beschreibung:</dt>
                    <dd>{description}</dd>
                  </dl>
                </div>

                <div className="data-group">
                  <h3>2. Bezug zur Schule</h3>
                  <dl>
                    <dt>Schulen:</dt>
                    <dd>{this.renderList('school')}</dd>
                    <dt>Lehrplan:</dt>
                    <dd>{curriculums}</dd>
                    <dt>Jahrgangsstufe:</dt>
                    <dd>{this.renderList('grade')}</dd>
                    <dt>Schulfächer:</dt>
                    <dd>{this.renderList('subject')}</dd>
                  </dl>
                </div>

                <div className="data-group">
                  <h3>3. Buchung &amp; Kosten</h3>
                  <dl>
                    <dt>buchbar von</dt>
                    <dd>
                      {formatMonth(bookingStart)}
                      {' '}
                      bis
                      {formatMonth(bookingEnd)}
                      <br />
                      {bookableOutOfOpeningTimes
                        ? 'auch außerhalb der Museumsöffnungszeiten buchbar'
                        : 'nicht außerhalb der Museumsöffnungszeiten'}
                    </dd>
                    <dt>Wochentage:</dt>
                    <dd>{this.renderList('day')}</dd>
                  </dl>

                  <div>
                    <strong>Kosten</strong>
                  </div>
                  <dl>
                    {prices.generalPrice ? <dt>Pauschalpreis:</dt> : null}
                    {prices.generalPrice ? (
                      <dd>
                        {prices.generalPrice}
                        {' '}
                        Euro
                      </dd>
                    ) : null}

                    {prices.minPrice ? <dt>Mindestpreis:</dt> : null}
                    {prices.minPrice ? (
                      <dd>
                        {prices.minPrice}
                        {' '}
                        Euro
                      </dd>
                    ) : null}

                    {prices.costsByPerson ? <dt>Preis pro Schüler:</dt> : null}
                    {prices.costsByPerson ? (
                      <dd>
                        {prices.costsByPerson}
                        {' '}
                        Euro
                      </dd>
                    ) : null}

                    {bookableOutOfOpeningTimes ? <dt /> : null}

                    {bookableOutOfOpeningTimes ? (
                      <dd>ja, außerhalb der Museumsöffnungszeiten buchbar</dd>
                    ) : null}

                    {specialConditionsForRemedialClasses ? <dt /> : null}
                    {specialConditionsForRemedialClasses ? (
                      <dd>Gesonderte Konditionen für Förderklassen</dd>
                    ) : null}

                    {freeEntryForTeachersAtPrevisit ? <dt /> : null}
                    {freeEntryForTeachersAtPrevisit ? (
                      <dd>Freier Eintritt für Lehrkräfte bei Vorbesuchen</dd>
                    ) : null}
                  </dl>
                </div>

                <div className="data-group">
                  <h3>4. Materialien</h3>

                  <dl>
                    <dt>Materialien:</dt>
                    <dd>{this.renderList('material')}</dd>
                    <dt>Methoden:</dt>
                    <dd>{this.renderList('method')}</dd>
                  </dl>
                </div>

                <div className="data-group">
                  <h3>5. Medien</h3>
                  <FileList list={links} type="file" />
                </div>

                <div className="data-group">
                  <FileList list={images} type="image" />
                </div>
              </div>

              <div className="col-xs-6">
                <div className="data-group">
                  <form
                    className="form form-horizontal"
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                  >
                    <div className="form-group">
                      <label className="col-xs-4" htmlFor="program-question">
                        Frage
                      </label>
                      <div className="col-xs-8">
                        <textarea
                          className="form-control"
                          id="program-question"
                          name="program-question"
                          required="true"
                          value={this.state.value}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="col-xs-8 col-xs-offset-4">
                        <button
                          className="action btn btn-primary"
                          type="submit"
                        >
                          Frage stellen
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

//

// <% _.each(links, function (link) { }
// <li>
//     <a href="{makeDataUrl(link.url) }">{link.name }</a>
//     <div>{link.pivot && link.pivot.description ? link.pivot.description : '' }</div>
// </li>
// <% }) }
// <% _.each(images, function (image) { }
// <li>
//     <img class="thumbnail" src="{makeDataUrl(image.url) }" />
//     {image.pivot && image.pivot.description ? image.pivot.description : '' }
// </li>
// <% }) }



// WEBPACK FOOTER //
// ./src/program/components/Details.js